export interface UserProfileInterface {
    username: string;
    verified: boolean;
    type: string;
    advanced: Record<string, string>;
    public: Record<string, string>;
    requisites: Record<string, string>;
    security: Record<string, string>;
}

export class UserProfile implements UserProfileInterface {
    username!: string;

    verified!: boolean;

    type!: string;

    advanced!: Record<string, string>;

    public!: Record<string, string>;

    requisites!: Record<string, string>;

    security!: Record<string, any>;
}

export class CoreState {
    profile: UserProfile | null = null;

    login(profile: UserProfile) {
      this.profile = profile;
    }

    logout() {
      this.profile = null;
    }

    getProfile(): UserProfile | null {
      return this.profile;
    }

    isLogged(): boolean {
      return Boolean(this.profile);
    }
}
